import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { type IncomeProtectionStepParams, incomeSchema } from './types'

export const income = (params: IncomeProtectionStepParams) => {
  const schema = incomeSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_incomeProtection:steps.income.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_occupational_disability_de.shape.configuration_parameters.shape.income.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_incomeProtection:steps.income.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('income'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'illness',
    subFlow: SubFlow.IncomeProtection,
  } as const satisfies AnyStepConfiguration
}
